(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ride-calendar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (value) => String(value).padStart(2, '0');
    const localDateKey = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    const parseLocal = (value) => {
      if (!value) return null;
      const normalized = value.length === 10 ? `${value}T00:00` : value;
      const match = normalized.match(/^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}))?/);
      if (!match) return new Date(value);
      return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]), Number(match[4] || 0), Number(match[5] || 0));
    };
    const escapeIcs = (value = '') => String(value).replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
    const icsDate = (date) => `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}T${pad(date.getHours())}${pad(date.getMinutes())}00`;

    document.querySelectorAll('[data-ride-calendar]').forEach((root) => {
      const text = {
        more: root.dataset.messageMore,
        free: root.dataset.messageFree,
        submitError: root.dataset.messageSubmitError,
        submitSuccess: root.dataset.messageSubmitSuccess,
        endpointMissing: root.dataset.messageEndpointMissing,
        fileTooLarge: root.dataset.messageFileTooLarge,
        invalidFile: root.dataset.messageInvalidFile,
        event: root.dataset.messageEvent,
        motorcycleEvent: root.dataset.messageMotorcycleEvent,
        flyerAlt: root.dataset.messageFlyerAlt
      };
      const raw = root.querySelector('[data-ride-events]');
      let events = [];
      try { events = JSON.parse(raw?.textContent || '[]'); } catch (error) { events = []; }
      events = events.filter((event) => event.title && event.start).map((event) => ({ ...event, startDate: parseLocal(event.start), endDate: parseLocal(event.end) }));

      const grid = root.querySelector('[data-calendar-grid]');
      const monthView = root.querySelector('[data-month-view]');
      const listView = root.querySelector('[data-list-view]');
      const monthLabel = root.querySelector('[data-calendar-month]');
      const empty = root.querySelector('[data-calendar-empty]');
      const search = root.querySelector('[data-event-search]');
      const categoryFilter = root.querySelector('[data-event-category]');
      const countryFilter = root.querySelector('[data-event-country]');
      const eventDialog = root.querySelector('[data-event-dialog]');
      const submitDialog = root.querySelector('[data-submit-dialog]');
      let cursor = new Date();
      cursor = new Date(cursor.getFullYear(), cursor.getMonth(), 1);
      let view = window.matchMedia('(max-width: 749px)').matches ? 'list' : 'month';

      const addOptions = (select, values) => {
        [...new Set(values.filter(Boolean))].sort((a, b) => a.localeCompare(b)).forEach((value) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          select.append(option);
        });
      };
      addOptions(categoryFilter, events.map((event) => event.category));
      addOptions(countryFilter, events.map((event) => event.country));

      const filteredEvents = () => {
        const query = search.value.trim().toLowerCase();
        return events.filter((event) => {
          const haystack = [event.title, event.description, event.city, event.region, event.country, event.venue, event.category].filter(Boolean).join(' ').toLowerCase();
          return (!query || haystack.includes(query)) && (!categoryFilter.value || event.category === categoryFilter.value) && (!countryFilter.value || event.country === countryFilter.value);
        }).sort((a, b) => a.startDate - b.startDate);
      };

      const formatDate = (event, options = {}) => {
        const dateText = new Intl.DateTimeFormat(undefined, { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric', ...options }).format(event.startDate);
        const timeText = new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' }).format(event.startDate);
        return `${dateText} · ${timeText}${event.timezone ? ` (${event.timezone})` : ''}`;
      };
      const locationText = (event) => [event.venue, event.city, event.region, event.country].filter(Boolean).join(', ');
      const fullAddress = (event) => [event.venue, event.address, event.city, event.region, event.country].filter(Boolean).join(', ');

      const openEvent = (event) => {
        const flyer = eventDialog.querySelector('[data-detail-flyer]');
        const flyerWrap = eventDialog.querySelector('[data-detail-flyer-wrap]');
        flyerWrap.hidden = !event.flyer;
        if (event.flyer) {
          flyer.src = event.flyer;
          flyer.alt = text.flyerAlt.replace('__TITLE__', event.title);
        }
        eventDialog.querySelector('[data-detail-category]').textContent = event.category || text.motorcycleEvent;
        eventDialog.querySelector('[data-detail-title]').textContent = event.title;
        eventDialog.querySelector('[data-detail-date]').textContent = formatDate(event);
        eventDialog.querySelector('[data-detail-location]').textContent = fullAddress(event);
        eventDialog.querySelector('[data-detail-admission]').textContent = event.admission || text.free;
        eventDialog.querySelector('[data-detail-description]').textContent = event.description || '';
        const ticket = eventDialog.querySelector('[data-detail-ticket]');
        ticket.hidden = !event.ticketUrl;
        if (event.ticketUrl) { ticket.href = event.ticketUrl; ticket.target = '_blank'; ticket.rel = 'noopener'; }
        eventDialog.querySelector('[data-detail-directions]').href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress(event))}`;
        const endDate = event.endDate || new Date(event.startDate.getTime() + 2 * 60 * 60 * 1000);
        const googleDates = `${icsDate(event.startDate)}/${icsDate(endDate)}`;
        eventDialog.querySelector('[data-detail-google]').href = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(event.title)}&dates=${googleDates}&details=${encodeURIComponent(event.description || '')}&location=${encodeURIComponent(fullAddress(event))}`;
        eventDialog.querySelector('[data-detail-ics]').onclick = () => {
          const body = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Real Stunt News//Ride Calendar//EN', 'BEGIN:VEVENT', `UID:${escapeIcs(event.id || `${Date.now()}@realstuntnews.com`)}`, `DTSTART:${icsDate(event.startDate)}`, `DTEND:${icsDate(endDate)}`, `SUMMARY:${escapeIcs(event.title)}`, `DESCRIPTION:${escapeIcs(event.description)}`, `LOCATION:${escapeIcs(fullAddress(event))}`, 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
          const link = document.createElement('a');
          link.href = URL.createObjectURL(new Blob([body], { type: 'text/calendar' }));
          link.download = `${event.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'ride-event'}.ics`;
          link.click();
          URL.revokeObjectURL(link.href);
        };
        eventDialog.showModal();
      };

      const createEventButton = (event, className) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = className;
        button.addEventListener('click', () => openEvent(event));
        return button;
      };

      const renderMonth = (visible) => {
        grid.innerHTML = '';
        const first = new Date(cursor.getFullYear(), cursor.getMonth(), 1);
        const start = new Date(first);
        start.setDate(first.getDate() - first.getDay());
        for (let index = 0; index < 42; index += 1) {
          const date = new Date(start);
          date.setDate(start.getDate() + index);
          const day = document.createElement('div');
          day.className = 'ride-calendar__day';
          if (date.getMonth() !== cursor.getMonth()) day.classList.add('is-outside');
          if (localDateKey(date) === localDateKey(new Date())) day.classList.add('is-today');
          const number = document.createElement('span');
          number.className = 'ride-calendar__day-number';
          number.textContent = date.getDate();
          day.append(number);
          const holder = document.createElement('div');
          holder.className = 'ride-calendar__day-events';
          const daily = visible.filter((event) => localDateKey(event.startDate) === localDateKey(date));
          daily.slice(0, 3).forEach((event) => {
            const button = createEventButton(event, 'ride-calendar__event-pill');
            button.textContent = event.title;
            button.title = `${event.title} — ${locationText(event)}`;
            holder.append(button);
          });
          if (daily.length > 3) {
            const more = document.createElement('p');
            more.className = 'ride-calendar__more';
            more.textContent = `+${daily.length - 3} ${text.more}`;
            holder.append(more);
          }
          day.append(holder);
          grid.append(day);
        }
      };

      const renderList = (visible) => {
        listView.innerHTML = '';
        const monthEvents = visible.filter((event) => event.startDate.getFullYear() === cursor.getFullYear() && event.startDate.getMonth() === cursor.getMonth());
        const groups = new Map();
        monthEvents.forEach((event) => {
          const key = localDateKey(event.startDate);
          if (!groups.has(key)) groups.set(key, []);
          groups.get(key).push(event);
        });
        groups.forEach((groupEvents) => {
          const wrapper = document.createElement('div');
          wrapper.className = 'ride-calendar__list-group';
          const heading = document.createElement('h3');
          heading.className = 'ride-calendar__list-date';
          heading.textContent = new Intl.DateTimeFormat(undefined, { weekday: 'long', month: 'long', day: 'numeric' }).format(groupEvents[0].startDate);
          wrapper.append(heading);
          groupEvents.forEach((event) => {
            const button = createEventButton(event, 'ride-calendar__list-event');
            const time = document.createElement('span');
            time.className = 'ride-calendar__list-time';
            time.textContent = new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' }).format(event.startDate);
            const copy = document.createElement('span');
            const title = document.createElement('strong');
            title.textContent = event.title;
            const location = document.createElement('span');
            location.textContent = locationText(event);
            copy.append(title, location);
            const category = document.createElement('span');
            category.className = 'ride-calendar__list-category';
            category.textContent = event.category || text.event;
            button.append(time, copy, category);
            wrapper.append(button);
          });
          listView.append(wrapper);
        });
        return monthEvents.length;
      };

      const render = () => {
        const visible = filteredEvents();
        monthLabel.textContent = new Intl.DateTimeFormat(undefined, { month: 'long', year: 'numeric' }).format(cursor);
        renderMonth(visible);
        const count = renderList(visible);
        empty.hidden = count > 0;
        monthView.hidden = view !== 'month' || count === 0;
        listView.hidden = view !== 'list' || count === 0;
      };

      root.querySelector('[data-calendar-previous]').addEventListener('click', () => { cursor = new Date(cursor.getFullYear(), cursor.getMonth() - 1, 1); render(); });
      root.querySelector('[data-calendar-next]').addEventListener('click', () => { cursor = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1); render(); });
      root.querySelector('[data-calendar-today]').addEventListener('click', () => { const today = new Date(); cursor = new Date(today.getFullYear(), today.getMonth(), 1); render(); });
      root.querySelectorAll('[data-view]').forEach((button) => button.addEventListener('click', () => {
        view = button.dataset.view;
        root.querySelectorAll('[data-view]').forEach((item) => item.classList.toggle('is-active', item === button));
        render();
      }));
      [search, categoryFilter, countryFilter].forEach((control) => control.addEventListener(control === search ? 'input' : 'change', render));
      root.querySelectorAll('[data-open-submit]').forEach((button) => button.addEventListener('click', () => submitDialog?.showModal()));
      root.querySelectorAll('[data-close-dialog]').forEach((button) => button.addEventListener('click', () => button.closest('dialog').close()));
      root.querySelectorAll('dialog').forEach((dialog) => dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      }));

      const form = root.querySelector('[data-event-form]');
      if (form) {
        const timezone = form.querySelector('[data-timezone-select]');
        const guessedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
        const zones = typeof Intl.supportedValuesOf === 'function' ? Intl.supportedValuesOf('timeZone') : ['UTC', 'America/Los_Angeles', 'America/Denver', 'America/Chicago', 'America/New_York', 'Europe/London', 'Europe/Paris', 'Asia/Tokyo', 'Australia/Sydney'];
        [...new Set([guessedTimezone, ...zones])].forEach((zone) => {
          const option = document.createElement('option');
          option.value = zone;
          option.textContent = zone.replace(/_/g, ' ');
          option.selected = zone === guessedTimezone;
          timezone.append(option);
        });
        const flyerInput = form.querySelector('[data-flyer-input]');
        const flyerPreview = form.querySelector('[data-flyer-preview]');
        const uploadZone = form.querySelector('[data-upload-zone]');
        ['dragenter', 'dragover'].forEach((name) => uploadZone.addEventListener(name, () => uploadZone.classList.add('is-dragging')));
        ['dragleave', 'drop'].forEach((name) => uploadZone.addEventListener(name, () => uploadZone.classList.remove('is-dragging')));
        flyerInput.addEventListener('change', () => {
          const file = flyerInput.files[0];
          if (!file) { flyerPreview.hidden = true; return; }
          if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) { flyerInput.setCustomValidity(text.invalidFile); flyerInput.reportValidity(); return; }
          if (file.size > 10 * 1024 * 1024) { flyerInput.setCustomValidity(text.fileTooLarge); flyerInput.reportValidity(); return; }
          flyerInput.setCustomValidity('');
          flyerPreview.src = URL.createObjectURL(file);
          flyerPreview.hidden = false;
        });
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const endpoint = root.dataset.submissionEndpoint;
          const message = form.querySelector('[data-form-message]');
          const submit = form.querySelector('[data-submit-button]');
          const showMessage = (copy, status) => { message.textContent = copy; message.className = `ride-calendar__form-message ride-calendar__field--wide is-visible is-${status}`; };
          if (!endpoint) { showMessage(text.endpointMissing, 'error'); return; }
          submit.disabled = true;
          submit.setAttribute('aria-busy', 'true');
          try {
            const response = await fetch(endpoint, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
            const result = await response.json().catch(() => ({}));
            if (!response.ok) throw new Error(result.error || text.submitError);
            form.reset();
            flyerPreview.hidden = true;
            showMessage(result.message || text.submitSuccess, 'success');
          } catch (error) {
            showMessage(error.message || text.submitError, 'error');
          } finally {
            submit.disabled = false;
            submit.removeAttribute('aria-busy');
          }
        });
      }
      render();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
